import OperationAreaRequestModel from '../../../generated/types/model/request/OperationAreaRequestModel';

export default class OperationAreaRequestViewModel extends OperationAreaRequestModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
